import type {PropsWithChildren} from 'react'

export const SlideoutBody = ({children}: PropsWithChildren) => (
  <div className={'sdox-scrollbar grow overflow-y-auto overflow-x-hidden'}>
    {children}
  </div>
)